import { Module } from 'vuex';
import { RootState } from '@/store/types';
import actions from '@/store/templates/actions';
import mutations from '@/store/templates/mutations';
import { TemplatesState } from './types';

const state: TemplatesState = {
  templates: [],
  templatesIsLoading: false,
};

const namespaced = true;

const templates: Module<TemplatesState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};

export default templates;
